import React from 'react'

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=''
    ref={ ref }
    className='dropdown-toggle'
    style={ {
      fontSize: '14px',
      padding: '8px 16px',
      color: '#212529',
      display: 'block',
    } }
    onClick={ (e) => {
      e.preventDefault();
      onClick(e);
    } }>
    {children}
  </a>
));

export default CustomToggle;